import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

export type InputLabelProps = {
  label: ReactNode;
  fieldName: string;
  required?: boolean;
  classNames?: {
    label?: string;
  };
};

export function InputLabel({
  label,
  required,
  fieldName,
  classNames,
}: InputLabelProps) {
  return (
    <label
      htmlFor={fieldName}
      className={cn('text-label-text-l mb-2 text-left', classNames?.label)}
    >
      {label}
      {required && '*'}
    </label>
  );
}
